import React from "react"
import { statusClass } from "../helpers/format"

const StatusChip = ({ status, label, dot = true }) => {
  if (!status && !label) return null
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium ring-1 ring-inset ${statusClass(status)}`}>
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />}
      {label || status}
    </span>
  )
}

export default StatusChip
